var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.707L13.293 0L0 13.293L0.707 14L1.707 13H12C12.2651 12.9996 12.5192 12.8941 12.7067 12.7067C12.8941 12.5192 12.9996 12.2651 13 12V1.707L14 0.707ZM12 12H2.707L6.6035 8.1035L7.793 9.293C7.98053 9.48047 8.23484 9.58579 8.5 9.58579C8.76516 9.58579 9.01947 9.48047 9.207 9.293L10 8.5L12 10.4985V12ZM12 9.084L10.707 7.791C10.5195 7.60353 10.2652 7.49821 10 7.49821C9.73484 7.49821 9.48053 7.60353 9.293 7.791L8.5 8.584L7.3115 7.3955L12 2.707V9.084ZM2 10V8.5L4.5 6.0015L5.1865 6.6885L5.8945 5.9805L5.207 5.293C5.01947 5.10553 4.76516 5.00021 4.5 5.00021C4.23484 5.00021 3.98053 5.10553 3.793 5.293L2 7.086V2H10V1H2C1.73486 1.00026 1.48066 1.10571 1.29319 1.29319C1.10571 1.48066 1.00026 1.73486 1 2V10H2Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no-image.843ff0ca.svg";
export { ForwardRef as ReactComponent };